import { render, staticRenderFns } from "./customDashboardFormbuilderDataTable.vue?vue&type=template&id=7df68ff0&scoped=true"
import script from "./customDashboardFormbuilderDataTable.vue?vue&type=script&lang=js"
export * from "./customDashboardFormbuilderDataTable.vue?vue&type=script&lang=js"
import style0 from "./customDashboardFormbuilderDataTable.vue?vue&type=style&index=0&id=7df68ff0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df68ff0",
  null
  
)

export default component.exports